import React, { useState } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import { useAppTheme } from '../contexts/ThemeContext'; // Seu hook renomeado

const ThemeSettings = React.memo(() => {
  const { palette, updatePalette, saveTheme, setPalette } = useAppTheme();
  const [localPalette, setLocalPalette] = useState({ ...palette });

  const handleChange = (key) => (e) => {
    setLocalPalette((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSave = async () => {
    setPalette(localPalette);

    setTimeout(async () => {
      console.log("🚀 Tentando chamar saveTheme:", typeof saveTheme); // Debug extra
      if (typeof saveTheme === "function") { 
        await saveTheme(); // ✅ Agora garantimos que é uma função antes de chamar
      } else {
        console.error("❌ Erro: saveTheme não é uma função!");
      }
    }, 500);

    alert("Tema salvo com sucesso!");
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Configurações de Tema
      </Typography>
      {["primary", "secondary", "background", "text"].map((key) => (
        <Box mb={2} key={key}>
          <TextField
            label={`Cor ${key.charAt(0).toUpperCase() + key.slice(1)}`}
            type="color"
            value={localPalette[key]}
            onChange={handleChange(key)}
            fullWidth
          />
        </Box>
      ))}
      <Button variant="contained" color="primary" onClick={handleSave}>
        Salvar Alterações
      </Button>
    </Box>
  );
});

export default ThemeSettings;
